import type { SVGProps } from "react";

export default function PencilIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9278 2.35917L11.7001 1.58677C12.9798 0.307014 15.0548 0.307014 16.3345 1.58677C17.6143 2.86652 17.6143 4.94141 16.3345 6.22117L15.5621 6.99356M10.9278 2.35917C10.9278 2.35917 11.0243 4.00052 12.4725 5.44877C13.9208 6.89701 15.5621 6.99356 15.5621 6.99356M2.45928 17.0255L1.79088 17.2483C1.47333 17.3541 1.12323 17.2715 0.886543 17.0348C0.649852 16.798 0.56721 16.448 0.67306 16.1305L0.89586 15.462L1.80732 12.7276C2.02242 12.0824 2.12996 11.7597 2.27463 11.4561C2.4453 11.098 2.65446 10.7596 2.89843 10.4468C3.10525 10.1816 3.34573 9.94121 3.8267 9.46021L10.9278 2.35917M15.5621 6.99356L8.4611 14.0946C7.9801 14.5755 7.73968 14.816 7.47452 15.0229C7.1617 15.2669 6.82326 15.476 6.46517 15.6467C6.1616 15.7914 5.83895 15.8989 5.19367 16.114L2.45928 17.0255M0.89586 15.462L2.45928 17.0255"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
